import { useEffect, useId, useRef } from "react";

export function SupportResolutionConfirmation({ busy, disabled, error, outcome, onOutcomeChange, onClose, onConfirm }: {
  busy: boolean; disabled: boolean; error: string; onClose: () => void; onConfirm: () => void;
  outcome: string; onOutcomeChange: (value: string) => void;
}) {
  const titleId = useId();
  const descriptionId = useId();
  const dialog = useRef<HTMLDialogElement>(null);
  const heading = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    const modal = dialog.current;
    const previousFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    modal?.showModal(); heading.current?.focus({ preventScroll: true });
    return () => { modal?.close(); if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true }); };
  }, []);
  return <dialog ref={dialog} aria-labelledby={titleId} aria-describedby={descriptionId}
    onCancel={event => { event.preventDefault(); if (!busy) onClose(); }}
    className="m-auto max-h-[90dvh] w-[calc(100%_-_2rem)] max-w-sm overflow-y-auto rounded-3xl border border-line bg-white p-6 text-center shadow-xl backdrop:bg-navy/50 sm:p-8">
    <h2 ref={heading} tabIndex={-1} id={titleId} className="text-xl font-bold text-navy outline-none">Resolve ticket?</h2>
    <p id={descriptionId} className="mt-3 break-words text-sm leading-6 text-mut">The member will receive your explanation. This ticket will permanently stop accepting replies.</p>
    <div className="support-field mt-4 text-left"><label htmlFor="support-outcome">Resolution / outcome (sent to member)</label><textarea id="support-outcome" className="field min-h-28" rows={4} required maxLength={2000} value={outcome} disabled={busy || disabled} onChange={event => onOutcomeChange(event.target.value)} /></div>
    {error && <p role="alert" className="mt-4 break-words text-sm text-brand-red">{error}</p>}
    <div className="mt-6 grid grid-cols-2 gap-3">
      <button type="button" disabled={busy} onClick={onClose} className="btn-outline min-h-11 w-full bg-navy-50 text-sm disabled:opacity-50">Cancel</button>
      <button type="button" disabled={busy || disabled || !outcome.trim()} onClick={onConfirm} className="btn-red min-h-11 w-full text-sm disabled:opacity-50">{busy ? "Resolving…" : "Resolve"}</button>
    </div>
  </dialog>;
}
